import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IConsultarStatusMainframeDareState } from './types';

export const INITIAL_STATE: IConsultarStatusMainframeDareState = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IConsultarStatusMainframeDareState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_STATUS_DARE_MAINFRAME_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_STATUS_DARE_MAINFRAME_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.CONSULTAR_STATUS_DARE_MAINFRAME_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
